import React from 'react';
import OECDExplorer from './components/OECDExplorer';
import CancerPlanVisualizer from './components/CancerPlanVisualizer';

function App() {
  return (
    <div className="App">
      <OECDExplorer />
    </div>
  );
}

export default App;